<script lang="ts" setup>
import {
    computed, nextTick, onMounted, ref, watch,
} from 'vue'

// @ts-expect-error code samples
import * as redoc from 'redoc/bundles/redoc.standalone'

// TODO: export types doesnt work now https://github.com/vuejs/core/issues/4294
interface ApiSelectorProps {
    scheme?: string
    host?: string
}

const props = withDefaults(defineProps<ApiSelectorProps>(), {
    scheme: 'billing',
    host: '',
})

const initialized = ref(false)
const redocContainer = ref(null)

const isBillingScheme = computed(() => props.scheme === 'billing')
const isDbExplorerScheme = computed(() => props.scheme === 'dbExplorer')

const hostname = computed(() => {
    if (props.host === 'rest.control.kidzonet.io') {
        return 'rest.kidzonet.io'
    }
    if (props.host === 'rest.control.kidzonet.cloud') {
        return 'rest.kidzonet.cloud'
    }
    return props.host
})

interface OpenapiScheme {
    host?: string
    schemes?: string[]
    paths?: any
}

const getOpenapiScheme = async (): Promise<OpenapiScheme> => {
    if (isBillingScheme.value) {
        const scheme = await import('./swagger/kznctl_pb/billing/public.swagger.json')
        return scheme.default
    }
    if (isDbExplorerScheme.value) {
        const scheme = await import('./swagger/kznctl_pb/db_explorer/public.swagger.json')
        return scheme.default
    }
    return {}
}

const getSanitizedScheme = async () => {
    const scheme = await getOpenapiScheme()
    scheme.host = hostname.value
    scheme.schemes = ['https']
    return scheme
}

const initilizeRedoc = async () => {
    window.scrollTo(0, 0)
    if (initialized.value) {
        window.location.hash = ''
    }
    const scheme = await getSanitizedScheme()
    await nextTick()
    redoc.init(
        scheme,
        {
            scrollYOffset: 64,
            hideDownloadButton: true,
        },
        redocContainer.value,
    )
}

onMounted(async () => {
    await initilizeRedoc()
    initialized.value = true
})

watch(() => props.scheme, () => {
    initilizeRedoc()
})
</script>

<template>
    <div ref="redocContainer" />
</template>
